import { ApolloQueryResult } from '@apollo/client';
import { pick } from 'lodash';
import type { GetSeoSerpQuestionsQuery } from '@marketmuse/config/types/papi';
import { GetSeoSerpQuestionsDocument } from '@marketmuse/data-papi';
import {
  ResearchDataInput,
  ResearchThunkSeoRes,
  ThunkApiConfig,
} from '../../types';
import createNonConcurrentAsyncThunk from '../../utils/createNonConcurrentAsyncThunk';

const getSerpQuestions = createNonConcurrentAsyncThunk<
  ResearchThunkSeoRes,
  ResearchDataInput,
  ThunkApiConfig
>('runs/getSerpQuestions', async (params, { extra, rejectWithValue }) => {
  const response: ApolloQueryResult<GetSeoSerpQuestionsQuery> =
    await extra.apollo.query({
      query: GetSeoSerpQuestionsDocument,
      variables: pick(params, ['term', 'country', 'language']),
    });

  const error = response.errors;
  if (error) {
    return rejectWithValue(error);
  }

  return {
    data: response?.data?.seoSerpQuestions.map(item => ({
      ...item,
      existsInInventory: false,
    })),
    path: 'serpQuestions',
    params,
  };
});

export default getSerpQuestions;
